import React from 'react';
import PropTypes from 'prop-types';
import PendingCardLoading from '../../TradeCard/ListTradeCard/PendingCardLoading';
import PendingNegotiationCard from '../../TradeCard/PendingNegotiationCard';
import { TradeContext } from '../../../_shared/types/trade';
import PendingDecisionCard from '../../TradeCard/PendingDecisionCard';
import PendingListCardVariant from '../../../_shared/constants/pendingListCardVariant';

const propTypes = {
  id: PropTypes.string.isRequired,
  tradeContext: PropTypes.oneOf([TradeContext.Buy, TradeContext.Sell])
    .isRequired,
  tradeList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number
    })
  ),
  isLoading: PropTypes.bool.isRequired,
  emptyCardComponent: PropTypes.element.isRequired,
  listCardVariant: PropTypes.oneOf([
    PendingListCardVariant.DECISION,
    PendingListCardVariant.NEGOTIATION
  ]).isRequired
};

const defaultProps = {
  tradeList: []
};

const PendingListCards = ({
  id,
  tradeContext,
  tradeList,
  isLoading,
  listCardVariant,
  emptyCardComponent,
  isOmp = false,
  handleNavigateToTradeUri
}) => {
  if (isLoading) return <PendingCardLoading />;

  if (tradeList?.length === 0) {
    return emptyCardComponent;
  }

  const getListCardForTrade = trade => {
    switch (listCardVariant) {
      case PendingListCardVariant.DECISION:
        return (
          <PendingDecisionCard
            id={`${id}-${trade.id}`}
            key={`${id}-${trade.id}`}
            testId={`${id}-${trade.id}`}
            tradeSummary={trade}
            tradeContext={tradeContext}
            isOmp={isOmp}
            handleNavigateToTradeUri={handleNavigateToTradeUri}
          />
        );
      case PendingListCardVariant.NEGOTIATION:
        return (
          <PendingNegotiationCard
            id={`${id}-${trade.id}`}
            key={`${id}-${trade.id}`}
            testId={`${id}-${trade.id}`}
            trade={trade}
            tradeContext={tradeContext}
            isOmp={isOmp}
            handleNavigateToTradeUri={handleNavigateToTradeUri}
          />
        );
      default:
        return null;
    }
  };

  return <>{tradeList?.map(trade => getListCardForTrade(trade))}</>;
};

PendingListCards.propTypes = propTypes;
PendingListCards.defaultProps = defaultProps;

export default PendingListCards;
